import { toast } from "sonner";
import { encryptLocalStorage } from "../utils/localStorage.utils";
import { getApi, imageUploadApi, postApi } from "./call.api"
import { urlApi } from "./url.api"

export const getAppLanguageList = async () => {
    let resp = await getApi(urlApi.getAppLanguages);
    if (resp.responseCode === 200) {
        encryptLocalStorage('app-language-list', resp.data);
    } else {
        encryptLocalStorage('app-language-list', []);
    }
    return;
}

export const getAllLanguages = async () => {
    let resp = await getApi(urlApi.getAllLanguageList);
    if (resp.responseCode === 200) {
        encryptLocalStorage('all-language-list', resp.data);
    } else {
        encryptLocalStorage('all-language-list', []);
    }
    return;
};

export const getAllCategories = async () => {
    let resp = await getApi(urlApi.getAllCategoryList);
    if (resp.responseCode === 200) {
        encryptLocalStorage('category-list', resp.data);
    } else {
        encryptLocalStorage('category-list', []);
    }
}

export const getAccessList = async () => {
    let resp = await getApi(urlApi.myAccessList);
    if (resp.responseCode === 200) {
        encryptLocalStorage('admin-access-list', resp.data);
    } else {
        encryptLocalStorage('admin-access-list', []);
    }
};

export const uploadImage = async (file, folderName) => {
    const formData = new FormData();
    formData.append('image', file);
    let resp = await imageUploadApi(formData, urlApi.imageUpload + "?folderName=" + folderName);
    if (resp.responseCode === 200) {
        return resp.data;
    } else {
        toast.error(resp.message)
        return null;
    }
}

export const uploadWhatsappTemplateImage = async (file, folderName) => {
    const formData = new FormData();
    formData.append('image', file);
    let resp = await imageUploadApi(formData, urlApi.whatsAppTemplateImageUploadApi);
    if (resp.responseCode === 200) {

        return resp.data;
    } else {
        toast.error(resp.message)
        return null;
    }
}

export const uploadWhatsappTemplateVideo = async (file, folderName) => {
    const formData = new FormData();
    formData.append('video', file);
    let resp = await imageUploadApi(formData, urlApi.whatsAppTemplateVideoUploadApi);
    if (resp.responseCode === 200) {
        console.log(resp);
        return resp.data;
    } else {
        toast.error(resp.message)
        return null;
    }
}

export const uploadImageNew = async (file, folder) => {
    if (!file) {
        toast.error("No file selected");
        return null;
    }

    const formData = new FormData();
    formData.append("file_data", file);
    formData.append("folderName", folder);

    try {
        const resp = await fetch(urlApi.fileUpload, {
            method: "POST",
            body: formData,
        }).then(r => r.json());

        console.log("Upload response:", resp);
        if (resp.responseCode === 200) return resp.data;
        toast.error(resp.message);
        return null;
    } catch (err) {
        console.error(err);
        toast.error("Upload failed");
        return null;
    }
};